import React from "react";
import { Link } from "react-router-dom";
import { HeartHandshake, ArrowRight } from "lucide-react";

export default function BuddiesOps() {
  return (
    <div className="space-y-4" data-testid="ops-buddies-page">
      <h1 className="text-2xl font-semibold text-slate-900">Buddies</h1>
      <div className="bg-white rounded-xl border p-6">
        <div className="flex items-start gap-4">
          <div className="w-11 h-11 rounded-xl bg-emerald-100 flex items-center justify-center">
            <HeartHandshake className="w-5 h-5 text-emerald-700" />
          </div>
          <div className="flex-1">
            <h2 className="text-lg font-semibold text-slate-900 mb-1">Buddy operations remain in the existing admin surface.</h2>
            <p className="text-sm text-slate-600 mb-4">
              The Buddy subsystem is authoritative for matching, entitlement, sessions, and safety
              logic. This first Operations release surfaces Buddy applications in the onboarding
              queue (read-only) and defers all Buddy actions to the existing Buddy admin console.
            </p>
            <Link to="/portal/admin/buddies" className="btc-btn-primary" data-testid="ops-buddies-open-admin">
              Open Buddy admin <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
